import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
   selector: 'app-executionsignature-authority',
   imports: [],
   templateUrl: './executionsignature-authority.component.html',
   styleUrl: './executionsignature-authority.component.css'
})
export class ExecutionsignatureAuthorityComponent {
  constructor(private router: Router) {
    this.downloadSignature();
  }

  downloadSignature() {
    this.router.navigate(['/DOA']);
    const link = document.createElement('a');
    link.href = 'assets/NMA_Signature_Authority.docx'; 
    link.download = 'NMA_Signature_Authority.docx';
    link.click();
  }
}
